import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Plan upsell CTA (T9.5). The upgrade itself is a billing-portal redirect
 * (lib/api/clients.js) — the portal never mutates the subscription itself.
 */
function ClientUpgradeCTA({ onOpenBillingPortal }) {
  return (
    <section className="portal-card portal-upgrade">
      <div>
        <h2>Need more capacity?</h2>
        <p>
          Scale tasks and agent hours without renegotiating. Your plan changes at
          the next billing cycle — no forms, no waiting.
        </p>
      </div>
      <button className="portal-primary-button" onClick={onOpenBillingPortal} type="button">
        Upgrade plan
      </button>
      <small>Prefer a bespoke agreement? <Link to="/client/support">Talk to us</Link>.</small>
    </section>
  );
}

export default ClientUpgradeCTA;
